import { usePermissions } from '@/hooks/usePermissions';
import { Action, Subject } from '@/lib/permissions';
import * as React from 'react';

interface CanAccessProps {
  action: Action;
  subject: Subject;
}

export const CanAccess: React.FC<React.PropsWithChildren<CanAccessProps>> = ({
  action,
  subject,
  children,
}) => {
  const { can } = usePermissions();

  if (!can(action, subject)) {
    return null;
  }

  return <>{children}</>;
};
